import React from 'react';
import { HEX_ALPHA } from '../../utils/constants';
import { getText } from '../../utils/functions';
import { useIcons } from '../../utils/hooks';

/**
 * NavBar that floats on top of Showcase's image
 */
function ShowcaseNavBar({
	sections = [],
	translate,
	routing,
	setRouting,
	colors,

	/* OPTIONAL PROPS */
	classNameDIV = `max-w-screen-2xl md:m-auto font-lato opacity-90 hidden md:grid grid-cols-${sections.length}`,
	classNameNavBarFather = 'w-full'
}) {
	/* Icon hook */
	const { Triangle } = useIcons(colors);

	/* Default values for the styles */
	const defaultStyleDIV = {
		backgroundColor: `${colors?.primary}${HEX_ALPHA[30]}`,
		color: colors.secondary,
		position: 'absolute',
		top: '0px',
	};

	return <div
		id='ShowcaseNavBarFather'
		style={defaultStyleDIV}
		className={classNameNavBarFather}
	>
		<div
			id='ShowcaseNavBar'
			className={classNameDIV}
		>
			{sections.map(section => (
				<Section
					key={section.value}
					colors={colors}
					Icon={Triangle}
					currentSection={routing}
					onClick={setRouting}
					section={section}
					translate={translate}
				/>
			))}
		</div>
	</div>;
}

function Section({
	section,
	currentSection,
	colors,
	Icon,
	translate,
	onClick,

	/* OPTIONAL PROPS */
	classNameBTN = 'flex flex-col pb-3 px-10 items-center focus:outline-none',
	classNameIMG = 'absolute top-0',
	classNameSPAN = 'w-full mb-2 mt-5 align-text-bottom text-xl',
}) {
	/* Variable that checks if any point of the component is being hovered so style can be applied to the Box */
	const [hover, setHover] = React.useState(false);

	/* Default values for the styles */
	const defaultStyleSECTION = {
		backgroundColor: hover && `${colors?.primary}${HEX_ALPHA[80]}`,
		transition: 'all 200ms ease-in',
	};

	/* Mouseover Styling */
	const onMouseOver = () => setHover(true);
	const onMouseLeave = () => setHover(false);

	return <button
		className={classNameBTN}
		style={defaultStyleSECTION}
		onClick={() => onClick(section.value)}
		onMouseOver={onMouseOver}
		onMouseLeave={onMouseLeave}
	>
		{section === currentSection && Icon
		&& Icon({
			className: classNameIMG
		})
		}
		<span className={classNameSPAN}>
			{getText(section, translate)}
		</span>
	</button>;
}

export default ShowcaseNavBar;
